module.exports = __webpack_public_path__ + "static/22-a799356bd2f4477b5f5e3fd45511dd52.jpg";